var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.reporte.aiclave == 1)?_c('ExpJur'):_vm._e(),(_vm.reporte.aiclave == 5)?_c('RCMedico'):_vm._e(),(_vm.reporte.aiclave == 23)?_c('RLV'):_vm._e(),(_vm.reporte.aiclave == 24)?_c('Robo'):_vm._e(),(_vm.reporte.aiclave == 27)?_c('Civil'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }